/**
 * Root route (`/`) behavior:
 *  - authenticated  → /app/dashboard
 *  - unauthenticated → Vercel marketing site root (external redirect)
 *
 * The app subdomain no longer serves any internal marketing content;
 * `/` is not a landing page. Login is at /login (deep-link only).
 */
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import MarketingRedirect from "@/components/MarketingRedirect";

export default function RootRedirect() {
    const auth = useAuth();
    if (auth?.loading) {
        return (
            <div
                style={{
                    minHeight: "100vh", background: "#0F2747", color: "#EEF3F8",
                    display: "flex", alignItems: "center", justifyContent: "center",
                    fontFamily: "system-ui, sans-serif", fontSize: 13, letterSpacing: "0.15em",
                    textTransform: "uppercase", opacity: 0.75,
                }}
                data-testid="root-redirect-loading"
            >
                Loading…
            </div>
        );
    }
    if (auth?.user) {
        return <Navigate to="/app/dashboard" replace />;
    }
    return <MarketingRedirect />;
}
